var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ShowAlert)?_c('el-col',{attrs:{"span":24}},[_c('el-alert',{attrs:{"title":_vm.AlertTitle,"type":"error","description":_vm.AlertDescription,"show-icon":"","closable":_vm.IsClosable}}),_c('br'),_c('br')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }